// Which organisations have a logo. The gateway lists them under /v2/logos, so a page asks for a
// logo only where one exists; where the list is not available (an older backend), every logo is
// requested as before.

let known = null;          // Set of organisation ids with a logo, once loaded
let loading = null;

export function loadLogos() {
    if (!loading) {
        loading = fetch('/v2/logos', { credentials: 'same-origin' })
            .then(r => (r.ok ? r.json() : null))
            .then(ids => { if (Array.isArray(ids)) known = new Set(ids); })
            .catch(() => {});
    }
    return loading;
}

/** true, false, or null when the list is not (yet) known. */
export function hasLogo(iriOrId) {
    if (!known) return null;
    const id = String(iriOrId || '').replace(/.*:/, '');
    return known.has(id);
}

/** After a logo was uploaded for this organisation. */
export function rememberLogo(iriOrId) {
    if (known) known.add(String(iriOrId || '').replace(/.*:/, ''));
}

/** The id inside a /v1/documents?uri=/logo/<id>.png URL, or null. */
export function logoIdOfUrl(url) {
    const m = /\/logo\/([^/.]+)\.png/.exec(url || '');
    return m ? m[1] : null;
}
